"use client";

import { usePostHog } from "posthog-js/react";
import { useState } from "react";
import { createPortal } from "react-dom";
import CheckoutSummary from "@/components/billing/checkout-summary";
import { trackAdsCtaClick } from "@/components/ads/ads-tracking";
import { PRICING } from "@/lib/pricing-data";

interface BusinessPaidCheckoutCtaProps {
  ctaLocation: string;
  className?: string;
  id?: string;
  variant?: string;
  pageSlug?: string;
}

export function BusinessPaidCheckoutCta({
  ctaLocation,
  className,
  id,
  variant = "business-paid-v1",
  pageSlug = "business-ads",
}: BusinessPaidCheckoutCtaProps) {
  const [showSummary, setShowSummary] = useState(false);
  const posthog = usePostHog();
  const ctaText = `Start Business for ${PRICING.business.display}/month`;

  function handleClick() {
    trackAdsCtaClick(
      {
        variant,
        pageSlug,
        ctaLocation,
        ctaText,
        eventName: "business_checkout_started",
        offer: "business",
        value: PRICING.business.price,
        currency: "GBP",
      },
      posthog,
    );
    setShowSummary(true);
  }

  return (
    <>
      <button
        id={id}
        type="button"
        onClick={handleClick}
        className={
          className ??
          "inline-flex min-h-[52px] w-full items-center justify-center rounded-xl bg-accent px-6 py-4 text-base font-bold text-white shadow-lg transition hover:bg-accent-dark hover:shadow-xl sm:w-auto"
        }
      >
        {ctaText}
      </button>
      {/* Portal to <body>: the mobile-sticky placement lives inside a
          translate-y-* container, and a CSS transform re-scopes fixed-position
          descendants to the transformed ancestor instead of the viewport. */}
      {showSummary
        ? createPortal(
            <CheckoutSummary
              open
              priceId={PRICING.business.stripe.priceId}
              planLabel="business"
              onClose={() => setShowSummary(false)}
            />,
            document.body,
          )
        : null}
    </>
  );
}
